function insightechTrack(event, action) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: event,
    event_action: action,
  });
};

export { insightechTrack };